import React from "react";
import { classnames } from "../../utils/text";

import infoIcon from "../../assets/images/icon/info-icon.svg"
import Icon from "../Icon";
const Guide = ({
  name,
  color = 'main',
  className,
  textAlign = 'center',
  children,
  ...props
}) => {
  return (
    <div className={
      classnames(
        'guide-wrap',
        'guide-bar-wrap',
        `background-${color}-5`,
        `color-${color}-100`,
        `text-align-${textAlign}`,
        className
      )
    }>
      <Icon src={infoIcon} className={`icon-${color}`} />
      {children}
    </div>
  );
};
export default Guide;
